var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _g3, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSodaIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Soda_icon_svg__Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 840 840",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Soda_icon_svg__cls-1{fill:#f93444}.Soda_icon_svg__cls-2{fill:#fa505e}.Soda_icon_svg__cls-4{fill:#fff}.Soda_icon_svg__cls-5{fill:#cae0e3}.Soda_icon_svg__cls-7{fill:#95c2c7}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Soda_icon_svg__cls-2",
    d: "M456.65 689.99h-73.31c-51.78 0-94.99-39.52-99.6-91.09l-23.51-262.92h319.53L556.25 598.9c-4.61 51.57-47.83 91.09-99.6 91.09z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Soda_icon_svg__cls-1",
    d: "M456.65 697.99h-73.31c-27.04 0-52.93-10.05-72.89-28.3s-32.27-43.14-34.68-70.08l-24.29-271.64h337.03l-24.29 271.64c-2.41 26.94-14.73 51.82-34.68 70.08-19.96 18.25-45.84 28.3-72.89 28.3zM268.98 343.97l22.73 254.21c2.05 22.95 12.54 44.15 29.55 59.7 17 15.55 39.05 24.11 62.09 24.11h73.31c23.04 0 45.09-8.56 62.09-24.11 17-15.55 27.49-36.75 29.55-59.7l22.73-254.21H268.99z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M456.65 697.99h-73.31c-26.2 0-51.47-9.51-71.17-26.77-19.64-17.21-32.37-40.91-35.85-66.74l15.86-2.14c6.12 45.41 45.31 79.65 91.17 79.65h73.31c45.85 0 85.04-34.24 91.17-79.65l15.86 2.14c-3.48 25.83-16.21 49.53-35.85 66.74a107.955 107.955 0 01-71.17 26.77z",
    fill: "#e2142d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Soda_icon_svg__cls-4",
    d: "M469.61 550.06c36.27 0 69.43-12.03 93.85-31.76l5.2-58.17c-24.81 22.35-60.14 36.21-99.06 36.21h-99.22c-38.92 0-74.25-13.85-99.06-36.21l5.2 58.17c24.42 19.73 57.59 31.76 93.85 31.76h99.22z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "Soda_icon_svg__cls-5",
    d: "M469.61 558.06h-99.22c-36.99 0-72.11-11.91-98.88-33.54a7.967 7.967 0 01-2.94-5.51l-5.2-58.17a8 8 0 0113.32-6.66c24.08 21.7 58.24 34.15 93.7 34.15h99.22c35.46 0 69.62-12.45 93.7-34.15a7.983 7.983 0 018.93-1.21 7.99 7.99 0 014.39 7.87l-5.2 58.17a7.967 7.967 0 01-2.94 5.51c-26.77 21.63-61.89 33.54-98.88 33.54zM284.2 514.14c23.59 18.03 54.06 27.92 86.19 27.92h99.22c32.14 0 62.6-9.89 86.19-27.92l3.25-36.4c-25.24 17.05-56.9 26.58-89.45 26.58h-99.22c-32.55 0-64.21-9.54-89.45-26.58l3.25 36.4zM240.47 286.73h359.05v37.06c0 36.37-29.53 65.91-65.91 65.91H306.37c-36.37 0-65.91-29.53-65.91-65.91v-37.06z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "Soda_icon_svg__cls-7",
    d: "M533.62 397.7H306.38c-40.75 0-73.91-33.15-73.91-73.91v-37.06c0-4.42 3.58-8 8-8h359.05c4.42 0 8 3.58 8 8v37.06c0 40.75-33.15 73.91-73.91 73.91zM248.47 294.73v29.06c0 31.93 25.98 57.91 57.91 57.91h227.24c31.93 0 57.91-25.98 57.91-57.91v-29.06H248.47z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Soda_icon_svg__cls-4",
    x: 240.47,
    y: 220.83,
    width: 359.05,
    height: 131.81,
    rx: 65.91,
    ry: 65.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "Soda_icon_svg__cls-5",
    d: "M533.62 360.64H306.38c-40.75 0-73.91-33.15-73.91-73.91s33.15-73.91 73.91-73.91h227.24c40.75 0 73.91 33.15 73.91 73.91s-33.15 73.91-73.91 73.91zM306.38 228.83c-31.93 0-57.91 25.98-57.91 57.91s25.98 57.91 57.91 57.91h227.24c31.93 0 57.91-25.98 57.91-57.91s-25.98-57.91-57.91-57.91H306.38z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "Soda_icon_svg__cls-5",
    cx: 420,
    cy: 283.59,
    rx: 46.02,
    ry: 29.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "Soda_icon_svg__cls-5",
    d: "M420 321.3c-30.29 0-54.02-16.56-54.02-37.71s23.73-37.71 54.02-37.71 54.02 16.56 54.02 37.71S450.29 321.3 420 321.3zm0-59.41c-20.25 0-38.02 10.14-38.02 21.71s17.76 21.71 38.02 21.71 38.02-10.14 38.02-21.71-17.76-21.71-38.02-21.71z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Soda_icon_svg__cls-5",
    x: 398.65,
    y: 111.19,
    width: 42.7,
    height: 180.59,
    rx: 21.35,
    ry: 21.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "Soda_icon_svg__cls-7",
    d: "M420 299.78c-16.18 0-29.35-13.17-29.35-29.35V132.54c0-16.18 13.17-29.35 29.35-29.35s29.35 13.17 29.35 29.35v137.89c0 16.18-13.17 29.35-29.35 29.35zm0-180.59c-7.36 0-13.35 5.99-13.35 13.35v137.89c0 7.36 5.99 13.35 13.35 13.35s13.35-5.99 13.35-13.35V132.54c0-7.36-5.99-13.35-13.35-13.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.65 132.48c.04 11.76 9.58 21.28 21.35 21.28s21.31-9.52 21.35-21.28c-.04-11.76-9.58-21.28-21.35-21.28s-21.31 9.52-21.35 21.28z",
    fill: "#006c78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 161.76c-16.13 0-29.3-13.13-29.35-29.26v-.05c.05-16.13 13.21-29.26 29.35-29.26s29.3 13.13 29.35 29.26c-.05 16.18-13.21 29.31-29.35 29.31zm-13.35-29.28c.04 7.33 6.02 13.28 13.35 13.28s13.33-5.97 13.35-13.31c-.02-7.29-6.01-13.26-13.35-13.26s-13.31 5.96-13.35 13.28z",
    fill: "#2a848e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Soda_icon_svg__cls-2",
    d: "M399.97 277.84c3.12 8.43 11.41 14.35 21.01 13.92 11.47-.52 20.36-10.28 20.36-21.76v-14.32l-40.75 20.62c-.56.28-.85.95-.63 1.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Soda_icon_svg__cls-1",
    d: "M420 299.78c-12.28 0-23.23-7.56-27.53-19.16-1.63-4.4.32-9.33 4.52-11.45l52.36-26.5V270c0 15.98-12.3 29.05-28 29.75-.45.02-.9.03-1.35.03zm-9.2-19.67c2.57 2.45 6.08 3.83 9.83 3.66 7.02-.32 12.72-6.49 12.72-13.77v-1.3l-22.56 11.42zm-3.32-5.04z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Soda_icon_svg__cls-2",
    d: "M398.65 200.21v30.07l42.7-21.61v-30.06l-42.7 21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Soda_icon_svg__cls-1",
    d: "M390.65 243.29v-48l58.7-29.7v48l-58.7 29.7zm16-38.16v12.13l26.7-13.51v-12.13l-26.7 13.51z"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "Soda_icon_svg__cls-7",
    d: "M468.8 360.64h-97.59c-4.42 0-8-3.58-8-8s3.58-8 8-8h97.59c4.42 0 8 3.58 8 8s-3.58 8-8 8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSodaIcon);
export default ForwardRef;